/**
 * Состав пака «survey-form» (WEB-3718) — смысл групп и источник каждого числа:
 * `../stylePackComposition.ts`. Файл на пак, общий список `./index.ts`
 * собирается по каталогу (решение владельца 23.10 ~04:35).
 */
import type { StylePackComposition } from '../stylePack.types';

export const composition: StylePackComposition = {
  // 92 воронок: группы.json, группы 3, 8, 10, 11, 14 (PACK в matrix.py)
  palettes: [
    // 14 из 92 воронок: palette → ближайшая тема по цветам
    { themeId: 'ink-premium', weight: 0.15 },
    // 8 из 92 воронок: palette → ближайшая тема по цветам
    { themeId: 'study-blue', weight: 0.09 },
    // 6 из 92 воронок: palette → ближайшая тема по цветам
    { themeId: 'trust-blue', weight: 0.07 },
  ],
  fonts: [
    // 66 из 92 воронок: fontId
    { fontId: 'inter', weight: 0.72 },
    // 13 из 92 воронок: fontId
    { fontId: 'poppins', weight: 0.14 },
    // 7 из 92 воронок: fontId
    { fontId: 'opensans', weight: 0.08 },
  ],
  screenKinds: [
    // средняя доля экранов по 92 воронкам (признаки.json kinds) 0.429; сюда свёрнуты Q10, Q13, Q6, Q9 (замена из arsenal.mjs)
    { kind: 'Q1', share: 0.5 },
    // средняя доля экранов по 92 воронкам (признаки.json kinds) 0.097; сюда свёрнуты I2 (замена из arsenal.mjs)
    { kind: 'I1', share: 0.11 },
    // средняя доля экранов по 92 воронкам (признаки.json kinds) 0.083; сюда свёрнуты Q11, Q3 (замена из arsenal.mjs)
    { kind: 'Q2', share: 0.1 },
    // средняя доля экранов по 92 воронкам (признаки.json kinds) 0.064
    { kind: 'N5', share: 0.08 },
    // средняя доля экранов по 92 воронкам (признаки.json kinds) 0.053; сюда свёрнуты Q16 (замена из arsenal.mjs)
    { kind: 'N4', share: 0.06 },
    // средняя доля экранов по 92 воронкам (признаки.json kinds) 0.050
    { kind: 'N1', share: 0.06 },
    // средняя доля экранов по 92 воронкам (признаки.json kinds) 0.042
    { kind: 'N8', share: 0.05 },
    // средняя доля экранов по 92 воронкам (признаки.json kinds) 0.037; сюда свёрнуты Q7 (замена из arsenal.mjs)
    { kind: 'Q5', share: 0.04 },
  ],
  blocks: [
    // в 92 из 92 воронок (признаки.json blocks), подъём 1.46; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): autoAdvance 1106 из 1381, optionIndicator 1218 из 1381
    {
      type: 'single_choice',
      weight: 1.0,
      settings: { autoAdvance: true, optionIndicator: 'none' },
    },
    // в 69 из 92 воронок (признаки.json blocks), подъём 1.66
    { type: 'multiple_choice', weight: 0.75, settings: {} },
    // в 62 из 92 воронок (признаки.json blocks), подъём 1.67
    { type: 'email', weight: 0.67, settings: {} },
    // в 56 из 92 воронок (признаки.json blocks), подъём 1.27
    { type: 'loader_processing', weight: 0.61, settings: {} },
    // в 26 из 92 воронок (признаки.json blocks), подъём 1.73
    { type: 'name_field', weight: 0.28, settings: {} },
    // в 33 из 92 воронок (признаки.json blocks), подъём 1.24
    { type: 'text_field', weight: 0.36, settings: {} },
    // в 23 из 92 воронок (признаки.json blocks), подъём 1.63
    { type: 'height_picker', weight: 0.25, settings: {} },
  ],
  niches: [
    // 10 из 92 воронок (признаки.json theme)
    { niche: 'health', weight: 0.11 },
    // 10 из 92 воронок (признаки.json theme)
    { niche: 'weight_loss', weight: 0.11 },
    // 9 из 92 воронок (признаки.json theme)
    { niche: 'nutrition', weight: 0.1 },
    // 9 из 92 воронок (признаки.json theme)
    { niche: 'mental_health', weight: 0.1 },
  ],
};
